import * as React from 'react';
import {
    Card,
    Box,
    Stack,
    Typography,
    IconButton,
    Tooltip,
} from '@mui/material';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import {
    startOfToday,
    endOfToday,
    endOfTomorrow,
    endOfWeek,
    getDay,
} from 'date-fns';
import { TasksListFilter } from './TasksListFilter';
import { TasksListEmpty } from './TasksListEmpty';
import { TaskIcon } from '@app/tasks/TaskIcon';
import { useTaskDrawer } from '@app/tasks/drawer/TaskDrawer';

const today = new Date();
const todayDayOfWeek = getDay(today);
const isBeforeFriday = todayDayOfWeek < 5; // Friday is represented by 5
const startOfTodayDateISO = startOfToday().toISOString();
const endOfTodayDateISO = endOfToday().toISOString();
const endOfTomorrowDateISO = endOfTomorrow().toISOString();
const endOfWeekDateISO = endOfWeek(today, { weekStartsOn: 0 }).toISOString();

const taskFilters = {
    overdue: { doneDate: 'is.null', dueDate: { lt: startOfTodayDateISO } },
    today: {
        doneDate: 'is.null',
        dueDate: { gte: startOfTodayDateISO, lte: endOfTodayDateISO },
    },
    tomorrow: {
        doneDate: 'is.null',
        dueDate: { gt: endOfTodayDateISO, lt: endOfTomorrowDateISO },
    },
    thisWeek: {
        doneDate: 'is.null',
        dueDate: { gte: endOfTomorrowDateISO, lte: endOfWeekDateISO },
    },
    later: { doneDate: 'is.null', dueDate: { gt: endOfWeekDateISO } },
};

export const TasksList = () => {
    const { openDrawer } = useTaskDrawer();

    return (
        <Stack>
            <Box display="flex" alignItems="center" mb={1}>
                <Box mr={1} display="flex">
                    <TaskIcon />
                </Box>
                <Typography variant="h5" color="textSecondary">
                    Upcoming Tasks
                </Typography>
                <Tooltip title="Create task">
                    <IconButton
                        size="small"
                        sx={{
                            color: 'text.secondary',
                            ml: 'auto',
                        }}
                        onClick={() => openDrawer('create', null)}
                    >
                        <ControlPointIcon fontSize="inherit" color="primary" />
                    </IconButton>
                </Tooltip>
            </Box>
            <Card sx={{ p: 2 }}>
                <Stack>
                    <TasksListEmpty />
                    <TasksListFilter
                        title="Overdue"
                        filter={taskFilters.overdue}
                        openEditDrawer={id => openDrawer('edit', id)}
                    />
                    <TasksListFilter
                        title="Today"
                        filter={taskFilters.today}
                        openEditDrawer={id => openDrawer('edit', id)}
                    />
                    <TasksListFilter
                        title="Tomorrow"
                        filter={taskFilters.tomorrow}
                        openEditDrawer={id => openDrawer('edit', id)}
                    />
                    {isBeforeFriday && (
                        <TasksListFilter
                            title="This week"
                            filter={taskFilters.thisWeek}
                            openEditDrawer={id => openDrawer('edit', id)}
                        />
                    )}
                    <TasksListFilter
                        title="Later"
                        filter={taskFilters.later}
                        openEditDrawer={id => openDrawer('edit', id)}
                    />
                </Stack>
            </Card>
        </Stack>
    );
};
